import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CustomNextArrow, CustomPrevArrow } from "../../utility/CustomArrow";

const FirstBannerSection = ({ data }) => {
  const mainSliderSettings = {
    dots: true,
    infinite: data?.data_values.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    autoplaySpeed: 3000,
    arrows: true,
  };

  return (
    <section className="container text-center py-3 mt-5 mb-5">
      <div className="row justify-content-center">
        <div className="col-lg-10 col-md-12 mb-4">
          <h1
            className="fw-bold fade-in"
            style={{ color: "#c69933", fontSize: "3rem" }}
          >
            Your Health Hub: Expert Care Across Multiple Specialties
          </h1>
          <p className="text-muted fade-in delay-1 h6">
            Welcome to Elite Body Home Polyclinic! Our warm and experienced team
            is excited to meet you. We offer comprehensive, high-quality care
            across various specialties, delivered by skilled doctors in a
            welcoming environment.
          </p>
          <p className="text-muted fade-in delay-2 h6  mt-5">
            At Elite Body Home, we focus on making you feel comfortable and
            confident from the moment you walk through our doors. We’re here to
            guide you, answer your questions, and ensure your skincare journey
            is smooth and enjoyable. Explore our services, and let’s start this
            radiant journey together!
          </p>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-lg-10 col-md-12">
          <Slider {...mainSliderSettings} className="rounded shadow">
            {data?.data_values.map((banner, index) => (
              <div
                key={index}
                className="d-flex align-items-center justify-content-center"
              >
                <div
                  className="rounded w-100 slider-image"
                  style={{
                    backgroundImage: `url(${banner?.Image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    height: "400px",
                    borderRadius: "10px",
                  }}
                >
                  <div
                    className="d-flex flex-column align-items-start justify-content-center h-100 text-white"
                    style={{ marginLeft: "20px" }}
                  >
                    <h4 className="fw-semibold slide-up text-black">
                      {banner?.Heading}
                    </h4>
                    <p className="fs-5 slide-up delay-1">{banner.subtitle}</p>
                    <div className="bg-dark p-3 rounded shadow slide-up delay-2">
                      <h4 className="mb-0 text-white">
                        Receive Medical Service
                      </h4>
                      <p className="mb-0 text-white">
                        Call Us at: Phone +971 551200086
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default FirstBannerSection;
